<template>
  <Layout >
    <PageHead :pageHeadData="PageHeadData"/>
    <ProductOverview 
      :summarizeText="SummarizeText" 
      :videoData="videoData"
    />
    
    <!-- 业务蓝图 -->
    <section 
      class="rn-section-gap slider-bg-image" 
      :style="{ 'background-image': `url(${require('@/assets/images/ProductService/common/business-blueprint.png')})` }">
      <SectionTitle :title="$t('product.business_blueprint')" description="BUSINESS BLUEPRINT" textAlign="center" />
      <div class="container">
        <CPQBusinessBlueprint  />
      </div>
    </section>

    <!-- 产品功能-->
    <ProductAbility
      :abilityData=AbilityData />
    
    <ProductSuperiority 
      :productSuperiorityData="ProductSuperiorityData" />
    <ClassicCases
    :classicCasesData="ClassicCasesData" />
  </Layout>
</template>

<script>
    import Layout from '../../components/common/Layout'
    import Separator from '../../components/elements/separator/Separator'
    import SectionTitle from '../../components/elements/sectionTitle/SectionTitle'
    import ProductOverview from './components/ProductOverview.vue'
    import CPQBusinessBlueprint from './components/BusinessBlueprint/CPQBusinessBlueprint.vue'
    import ProductAbility from './components/ProductAbility.vue'
    import PageHead from './components/PageHead.vue'
    import ProductSuperiority from './components/ProductSuperiority/ProductSuperiority.vue'
    import ClassicCases from '../IndustrySolution/components/ClassicCases.vue'
    import { 
        CPQUniversalModel,
        CPQFlexibleDeployment,
        CPQPerformanceImage,
        CPQSystemIntegrating,
        numImage01,
        numImage02,
        zhongtongBackground,
        HITACHIBackground,
        YTOBackground,
        zhongtongIcon,
        HITACHIIcon,
        YTOIcon,
        CPQAbility01,
        CPQAbility02,
      } from './Image.js'

    export default {
        name: 'VyungCPQ',
        components: {
         Layout, Separator, SectionTitle, 
          ProductOverview, CPQBusinessBlueprint, ProductAbility, PageHead,ProductSuperiority,ClassicCases,
        },
        data() {
            return {
                //页面头部
                PageHeadData:{
                  engTitle:'Configure Price Quote',
                  text: this.$t('product.VyungCPQ.head.text'),
                  subtitle: this.$t('product.VyungCPQ.head.subtitle'),
                  image:require('@/assets/images/ProductService/VyungCPQ/CPQ-Image.png'),
                },
                //产品概述
                videoData:[{
                    src:process.env.VUE_APP_VIDEO_URL+'/$web/video/cpq.mp4?'+process.env.VUE_APP_VIDEO_RAXWDL,
                    // src:'https://vyunghome.blob.core.chinacloudapi.cn/$web/video/cpq.mp4?sp=racwdl&st=2023-05-23T06:12:11Z&se=2023-06-23T14:12:11Z&spr=https&sv=2022-11-02&sr=c&sig=ajt5HDJh%2BGE7TJ%2Bdo8uNSAqOUJzZWan37uhgbk%2B7bRI%3D',
                    thumb: require(`@/assets/images/ProductService/VyungCPQ/CPQ-video.jpg`)
                }],
                SummarizeText: this.$t('product.VyungCPQ.product_overview.text'),
                //产品功能
                AbilityData:[
                  {
                    title: this.$t('product.VyungCPQ.product_ability.card01.title'),
                    text: this.$t('product.VyungCPQ.product_ability.card01.text'),
                    contentImage:CPQAbility01,
                    numImage:numImage01,
                  },
                  {
                    title: this.$t('product.VyungCPQ.product_ability.card02.title'),
                    text: this.$t('product.VyungCPQ.product_ability.card02.text'),
                    contentImage:CPQAbility02,
                    numImage:numImage02,
                  },
                ],

                //产品优势
                ProductSuperiorityData:[
                  {
                    title: this.$t('product.VyungCPQ.product_advangtages.card01.title'),
                    text: this.$t('product.VyungCPQ.product_advangtages.card01.text'),
                    contentImage:CPQUniversalModel,
                  },
                  {
                    title: this.$t('product.VyungCPQ.product_advangtages.card02.title'),
                    text: this.$t('product.VyungCPQ.product_advangtages.card02.text'),
                    contentImage:CPQFlexibleDeployment,
                  },
                  {
                    title: this.$t('product.VyungCPQ.product_advangtages.card03.title'),
                    text: this.$t('product.VyungCPQ.product_advangtages.card03.text'),
                    contentImage:CPQPerformanceImage,
                  },             
                  {
                    title: this.$t('product.VyungCPQ.product_advangtages.card04.title'),
                    text: this.$t('product.VyungCPQ.product_advangtages.card04.text'),
                    contentImage:CPQSystemIntegrating,
                  }
                ],

                //产品案例
                ClassicCasesData:[
                  {
                    // imageBackground: zhongtongBackground,
                    brandIcon: zhongtongIcon,
                  },
                  {
                    // imageBackground: HITACHIBackground,
                    brandIcon: HITACHIIcon,
                  },
                  {
                    // imageBackground: YTOBackground,
                    brandIcon: YTOIcon,
                  },
                ]
              }
        },
        methods:{
       
        }
    }
</script>